// extracted by mini-css-extract-plugin
export default {"footer":"AboutUs_footer__mcc-p","mainWrapper":"AboutUs_mainWrapper__9cPX3","white-paper":"AboutUs_white-paper__z1wqy","background":"AboutUs_background__7xD0n"};